<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import AllMasterProfesi from "./tab-master-profesi/all-master-profesi.vue";
import AllMasterDahanProfesi from "./tab-master-dahan-profesi/all-master-dahan-profesi.vue";
import AllMasterPohonProfesi from "./tab-master-pohon-profesi/all-master-pohon-profesi.vue";
import AllMasterPohonBisnis from "./tab-master-pohon-bisnis/all-master-pohon-bisnis.vue";
import AllKompetensiProfesi from "./tab-kompetensi-profesi/all-kompetensi-profesi.vue";
import axios from "axios";

/**
 * Starter component
 */
export default {
  page: {
    title: "Master Profesi",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    AllMasterProfesi,
    AllMasterDahanProfesi,
    AllMasterPohonProfesi,
    AllMasterPohonBisnis,
    AllKompetensiProfesi,
  },
  data() {
    return {
      title: "Master Profesi",
    };
  },
  methods: {
    async getDahanProfesi(search = "", loading) {
      let result = [];
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/dahan-profesi/all",
          {
            params: {
              search: search,
              limit: 20,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          result = response.data.data;
          if (loading) loading(false);
        });
      return result;
    },
  },
  provide() {
    return {
      getDP: this.getDahanProfesi,
    };
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="'Master Kompetensi'" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <b-card no-body>
          <b-tabs pills card>
            <b-tab title="Direktori Kompetensi" lazy>
              <AllKompetensiProfesi />
            </b-tab>
            <b-tab title="Master Profesi" active lazy>
              <AllMasterProfesi />
            </b-tab>
            <b-tab title="Master Dahan Profesi" lazy>
              <AllMasterDahanProfesi />
            </b-tab>
            <b-tab title="Master Pohon Profesi" lazy>
              <AllMasterPohonProfesi />
            </b-tab>
            <b-tab title="Master Pohon Bisnis" lazy>
              <AllMasterPohonBisnis />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </Layout>
</template>
